// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Backoffice__DetailedSetUsersController from "./backoffice/detailed_set_users_controller"
application.register("backoffice--detailed-set-users", Backoffice__DetailedSetUsersController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import ClearParamsController from "./clear_params_controller"
application.register("clear-params", ClearParamsController)
